import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

// Tom Select: https://tom-select.js.org/docs/

export default class extends Controller {
  connect() {
    this.instance = new TomSelect(this.element, {
      allowEmptyOption: true,
      maxOptions: null, // No limit on the number of options
    });
  }

  disconnect() {
    if (this.instance) {
      this.instance.destroy();
    }
  }
}
